module.exports = __webpack_public_path__ + "img/down.1d552d9.png";